export const handleFinishReason = (finishReason: string | null): void => {
  if (!finishReason) return;

  switch (finishReason) {
    case "IMAGE_SAFETY":
      throw new Error("Image generation blocked: Content potentially violates safety policies.");
    case "IMAGE_PROHIBITED_CONTENT":
      throw new Error("Image generation blocked: Content may contain prohibited material.");
    case "IMAGE_RECITATION":
      throw new Error("Image generation blocked: Content may be a recitation from a source.");
    case "IMAGE_OTHER":
      throw new Error("Image could not be generated by google ai, changing the prompt a bit and try again.");
    case "NO_IMAGE":
      throw new Error("The model was expected to generate an image, but didn't.");
    case "SAFETY":
      throw new Error("Content generation stopped: Potentially violates safety policies.");
    case "RECITATION":
      throw new Error("Content generation stopped: May be a recitation from a source.");
    case "BLOCKLIST":
      throw new Error("Content generation stopped: Contains a term from the blocklist.");
    case "PROHIBITED_CONTENT":
      throw new Error("Content generation stopped: May be prohibited content.");
    case "SPII":
      throw new Error("Content generation stopped: Contains sensitive personally identifiable information.");
    case "MAX_TOKENS":
      throw new Error("Content generation stopped: Maximum token limit reached.");
    case "MALFORMED_FUNCTION_CALL":
      throw new Error("Content generation stopped: Generated an invalid function call.");
    case "MODEL_ARMOR":
      throw new Error("Content generation blocked by Model Armor.");
    case "STOP":
    case "FINISH_REASON_UNSPECIFIED":
    case "OTHER":
      // These are normal completion reasons or unspecified, don't throw error
      break;
    default:
      console.warn(`Unknown finish reason: ${finishReason}`);
  }
};
